<template>
  <div
    class="activity-box"
    :class="{ version2: version === 2, version3: version === 3 }"
  >
    <div class="main version1" v-if="version === 1">
      <img class="bg" src="./images/bg.png" alt="" />
      <div class="item-box">
        <div class="item" v-for="item of giftList" :key="item.gift_id">
          <template v-if="item.gift_id">
            <div class="img-box">
              <img :src="item.url" alt="" />
            </div>

            <div>
              <span>
                {{ item.name }}
              </span>
              <span class="valid-time" v-if="item.validTime">{{
                item.validTime
              }}</span>
            </div>
            <div class="points">需要{{ item.points }}碎片</div>
            <button @click="exchange(item)"></button>
          </template>
        </div>
      </div>
      <div class="score">{{ score }}</div>
    </div>
    <div class="main version2" v-if="version === 2">
      <img class="bg" src="./images/bg2.png" alt="" />
      <div class="item-box">
        <div
          class="item"
          :class="{ empty: !item.gift_id }"
          v-for="item of giftList"
          :key="item.gift_id"
        >
          <template v-if="item.gift_id">
            <div class="img-box">
              <svg class="svg1" viewBox="0 0 100 100">
                <text fill="black" font-size="9" font-weight="bold">
                  <textPath
                    xlink:href="#circlePath"
                    startOffset="50%"
                    text-anchor="middle"
                  >
                    <tspan fill="#5eb2ed">{{ item.name }}</tspan>
                    <tspan fill="#de90ff">{{ item.validTime }}</tspan>
                  </textPath>
                </text>
                <path
                  id="circlePath"
                  d="M50,50 m-40,0 a40,40 0 1,1 80,0"
                  fill="transparent"
                />
              </svg>
              <!-- <svg class="svg2 parent" viewBox="0 0 100 100">
                <text fill="black" font-size="9" font-weight="bold">
                  <textPath
                    xlink:href="#circlePath2"
                    startOffset="50%"
                    text-anchor="middle"
                  >
                    <tspan fill="#f2a75f">需要</tspan>
                    <tspan fill="#2f2e32">{{ item.points }}</tspan>
                    <tspan fill="#f2a75f">碎片</tspan>
                  </textPath>
                </text>
                <path
                  id="circlePath2"
                  d="M50,50 m-40,0 a40,40 0 0,0 80,0"
                  fill="transparent"
                />
              </svg> -->
              <img class="gift" :src="item.url" alt="" />
              <div class="price">{{ item.points }}碎片</div>
            </div>
            <button @click="exchange(item)"></button>
          </template>
        </div>
      </div>
      <div class="score">{{ score }}</div>
    </div>
    <div class="main version3" v-if="version === 3">
      <img class="bg" src="./images/bg3.png" alt="" />
      <div class="item-box">
        <div
          class="item"
          :class="{ empty: !item.gift_id }"
          v-for="item of giftList"
          :key="item.gift_id"
        >
          <template v-if="item.gift_id">
            <div class="img-box">
              <img class="gift" :src="item.url" alt="" />
            </div>
            <button @click="exchange(item)"></button>
          </template>
        </div>
      </div>
      <div class="score">{{ score }}</div>
    </div>
    <el-dialog
      title=""
      :visible.sync="visible"
      width="346px"
      top="30vh"
      append-to-body
      :show-close="false"
      custom-class="legendary-store-dialog"
    >
      <div class="dialog-main">
        <img class="img-bg" src="./images/fail.png" v-show="!isExchange" />
        <img class="img-bg" src="./images/success.png" v-show="isExchange" />
        <img
          class="btn"
          src="./images/button.png"
          alt=""
          @click="closeDialog"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
import png150 from './images/150.png';
import png300 from './images/300.png';
export default {
  name: 'ActivityBox',
  data() {
    return {
      score: 0,
      visible: false,
      isExchange: false,
      isTest: false,
      exchangeLoading: null,
      png150,
      png300,
      version: 3
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 是否已登入狀態
    isLogined() {
      return this.userInfo && (this.token || this.refreshToken);
    },
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    giftList() {
      return [
        {
          gift_id: 1,
          name: '满150-10优惠券',
          points: 150,
          url: this.png150
        },
        {
          gift_id: 2,
          name: '满300-30优惠券',
          points: 450,
          url: this.png300
        },
        {
          gift_id: 3,
          name: '相爱（7天)',
          description: '相爱（7天) 需要1888碎片',
          points: 1888,
          url:
            'https://resource.3uplay.com/sys-feed/c8a283b6-8252-4e3d-a95d-22072606e8da4630501356497942990.webp'
        },

        {
          gift_id: 4,
          name: '相守（7天）',
          description: '相守（7天） 需要1888碎片',
          points: 1888,
          url:
            'https://resource.3uplay.com/sys-feed/eef4622a-c40c-402c-b661-e3f7a8086de3320403584671043896.webp'
        },

        {
          gift_id: null,
          name: '',
          validTime: '',
          description: '',
          points: 0
        },
        {
          gift_id: 6,
          name: '愚人劇團（7天）',
          description: '愚人劇團（7天）1888碎片',
          points: 1888,
          url: 'https://resource.3uplay.com/sys-feed/ceea1725.webp'
        },

        {
          gift_id: 7,
          name: '心花綻放（7天）',
          description: '心花綻放（7天） 需要1888碎片',
          points: 1888,
          url:
            'https://resource.3uplay.com/sys-feed/0bd96833-0ac3-493a-9ebc-4c5575321e87355419935355601408.webp'
        },
        {
          gift_id: 8,
          name: '搗蛋鬼（永久）',
          description: '搗蛋鬼（永久） 52000碎片',
          points: 52000,
          url:
            'https://resource.3uplay.com/sys-feed/c36791b2-6d2f-4774-a432-993cdc56bb5e5554735552447613343.webp'
        },
        {
          gift_id: 9,
          name: '小龍人（永久）',
          description: '小龍人（永久） 52000碎片',
          points: 52000,
          url: 'https://resource.3uplay.com/sys-feed/b956f90b.webp'
        }
      ];
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 檢查登入
    // 檢查登入
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    async getMyscore() {
      try {
        this.setLoading();
        const url = `https://devops.nicee.app/api/huodong/cangbaoge/points?uuid=${this.uuid}`;
        const data = await this.$http.get(url);
        if (data) {
          this.score = data.score || 0;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.closeLoading();
      }
    },
    async exchange(gift) {
      const { gift_id, points } = gift;
      if (gift_id === 'null') {
        return;
      }
      if (this.isTest) {
        this.score = 1000;
      } else {
        await this.checkLogin();
      }
      if (points > this.score) {
        this.isExchange = false;
        this.visible = true;
        return;
      }
      if (this.loading) {
        return;
      }
      this.$confirm({
        content: `當前積分${this.score},抽獎需${points}積分`,
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        closeOnClickOverlay: false
      }).then(async () => {
        this.loading = true;
        this.setLoading();
        try {
          const testPromise = new Promise(resolve => {
            setTimeout(() => {
              // resolve({ data: { result: 'fail' } });
              resolve({ result: 'success' });
            }, 3000);
          });
          const url = `https://devops.nicee.app/api/huodong/cangbaoge/gifts?uuid=${this.uuid}&giftid=${gift_id}`;
          const data = this.isTest
            ? await testPromise
            : await this.$http.get(url);
          if (data) {
            if (data.result === 'fail') {
              this.isExchange = false;
              this.visible = true;
            } else {
              this.isExchange = true;
              this.visible = true;
              this.score = this.score - points;
            }
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
          this.closeLoading();
        }
      });
    },
    closeDialog() {
      this.visible = false;
    },
    closeLoading() {
      if (this.exchangeLoading) {
        this.exchangeLoading.close();
      }
    },
    setLoading() {
      this.exchangeLoading = this.$loading({
        customClass: 'pointer-events__none',
        background: 'rgba(255, 255, 255, 0)',
        fullscreen: true
      });
    }
  },
  created() {},
  mounted() {
    // this.setLoading();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #f28962;
  overflow: auto;
  text-align: center;
  &.version2,
  &.version3 {
    background-image: url('./images/web-bg.png');
    background-size: 100% 100%;
    box-shadow: 0px 0px 72px rgba(184, 64, 75, 0.14);
  }
  .main {
    &.version1 {
      position: relative;
      display: inline-block;
      width: 980px;
      text-align: left;
      > .bg-img {
        width: 100%;
      }
      .item-box {
        position: absolute;
        top: 1725px;
        left: 82px;
        z-index: 2;
        display: flex;
        flex-wrap: wrap;

        .item {
          display: inline-block;
          height: 390px;
          width: 258px;
          margin-bottom: 55px;
          margin-right: 19px;
          font-size: 24px;
          line-height: 1.2;
          text-align: center;
          padding-top: 44px;
          .valid-time {
            background: #bf7b28;
            color: white;
            border-radius: 20px;
            padding: 0px 4px;
          }
          .img-box {
            height: 198px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .points {
            transform: scale(0.9);
          }

          button {
            width: 214px;
            height: 64px;
            margin-top: 10px;
            cursor: pointer;
          }
          img {
            max-width: calc(100% - 40px);
            max-height: calc(100% - 40px);
          }
        }
      }
      .score {
        position: absolute;
        top: 3200px;
        left: 653px;
        font-size: 51px;
        font-weight: bold;
      }
    }
    &.version2 {
      position: relative;
      display: inline-block;
      width: 1054px;
      text-align: left;
      > .bg-img {
        width: 100%;
      }
      .item-box {
        position: absolute;
        top: 1168px;
        left: 48px;
        z-index: 2;
        display: flex;
        flex-wrap: wrap;

        .item {
          // display: inline-block;
          height: 390px;
          width: 315px;
          margin-bottom: 16px;
          margin-right: 19px;
          font-size: 24px;
          line-height: 1.2;
          text-align: center;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          &.empty {
            margin-bottom: 18px;
          }

          .valid-time {
            background: #bf7b28;
            color: white;
            border-radius: 20px;
            padding: 0px 4px;
          }
          .img-box {
            width: 232px;
            height: 232px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            flex: none;
            .svg1 {
              position: absolute;
              width: 232px;
              height: 232px;
              top: 0;
              left: 0;
            }
            .price {
              position: absolute;
              width: 100%;
              bottom: -24px;
              left: 50%;
              transform: translate(-50%, 0);
              text-shadow: 2px 2px 1px #0a62eb, -1px -1px 2px #0a62eb;
              color: #fceffc;
              font-size: 32px;
            }
          }
          .points {
            transform: scale(0.9);
          }

          button {
            width: 214px;
            height: 90px;
            margin-top: 30px;
            cursor: pointer;
          }
          img {
            max-width: calc(100% - 64px);
            max-height: calc(100% - 40px);
          }
        }
      }
      .score {
        position: absolute;
        top: 2517px;
        left: 779px;
        font-size: 80px;
        font-weight: bold;
        color: #1775f8;
      }
    }

    &.version3 {
      position: relative;
      display: inline-block;
      width: 750px;
      text-align: left;
      > .bg-img {
        width: 100%;
      }
      .item-box {
        position: absolute;
        top: 1040px;
        left: 50%;
        transform: translateX(-50%);
        width: 638px;
        display: flex;
        flex-wrap: wrap;

        .item {
          width: 186px;
          height: 288px;
          margin-right: 40px;
          margin-bottom: 21px;
          display: flex;
          flex-direction: column;
          align-items: center;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .img-box {
            width: 154px;
            height: 96px;
            margin-top: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: none;
          }

          button {
            width: 186px;
            height: 80px;
            margin-top: 60px;
            cursor: pointer;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
      .score {
        position: absolute;
        top: 1503px;
        left: 546px;
        font-size: 42px;
        color: #2e2e2e;
        width: 204px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 50%;
        transform: translate(-50%);
      }
    }
  }
}
</style>
<style lang="scss">
.legendary-store-dialog {
  padding: 0;
  font-size: 0;
  background: rgba(0, 0, 0, 0);
  .el-dialog__body {
    padding: 0;
    .dialog-main {
      position: relative;
      width: 346px;
    }
    .img-bg {
      width: 346px;
      height: auto;
    }
    .btn {
      position: absolute;
      bottom: 30px;
      width: 144px;
      height: 38px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .van-dialog__footer {
    display: none;
  }
}
</style>
